import { ValidationErrors, AbstractControl, Validators } from '@angular/forms';


export module CustomValidators {
  export function optionalEmailValidator(control: AbstractControl): ValidationErrors | null {
    let value: string = control.value;
    if (!value)
      return null;
    if (!value.trim())
      return null;

    let ret = Validators.email(control);
    return ret;
  }


}

